<template>
    <el-table :data="reimbursementList" class="reimbursement-table" size="small" empty-text="無資料">
        <el-table-column prop="ioo" label="核銷單號" width="110">
            <template slot-scope="scope">
                <span :class="{ 'invoice-label': !disableInvoiceDialog }" @click="$emit('openInvoice', scope.row.originSno)">
                    {{ scope.row.ioo }}
                </span>
            </template>
        </el-table-column>
        <el-table-column prop="originStatus" label="狀態" width="110">
            <template slot-scope="scope">
                <InvoiceStatusLabel :statusNum="scope.row.originStatus" />
            </template>
        </el-table-column>
        <el-table-column prop="originDescription" label="摘要"> </el-table-column>
        <el-table-column prop="originAMT" label="核銷單總計" align="right" width="150">
            <template slot-scope="scope">
                <span>
                    <Money :v="scope.row.originAMT" :precision="scope.row.cny === 'TWD' ? null : 4" />
                </span>
            </template>
        </el-table-column>
        <el-table-column prop="amt" label="本次開立金額" align="right" width="150">
            <template slot-scope="scope">
                <span>
                    <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                </span>
            </template>
        </el-table-column>
        <el-table-column prop="originCNY" label="幣別" align="right"> </el-table-column>
        <el-table-column prop="originCrt_Nam" label="核銷申請人" align="right"> </el-table-column>
    </el-table>
</template>

<script>
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';

export default {
    props: {
        reimbursementList: {
            type: Array,
            default: () => [],
        },
        form: {
            type: Object,
            default: () => {},
        },
        disableInvoiceDialog: Boolean,
    },
    components: { InvoiceStatusLabel },
    data() {
        return {
            expend: true,
        };
    },
};
</script>

<style lang="scss" scoped>
.reimbursement-table {
    width: 100%;
    border-top: 1px solid #eee;
    margin: 50px 0;
    .invoice-label {
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>
